import axiosApi from '@/api/axiosApi';

export const save = (data) => {
    return axiosApi({
        url: '/intserv/learn/save',
        method: 'post',
        data
    })
}